module.exports = __webpack_public_path__ + "img/bb_g3_nose-04.f1786659.svg";